// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyC8-6h9v4Et725atBSQRfe_hWpEbbcUm1E",
  authDomain: "all-nippy.firebaseapp.com",
  projectId: "all-nippy",
  storageBucket: "all-nippy.appspot.com",
  messagingSenderId: "106180753721",
  appId: "1:106180753721:web:675b95fe869635fbd610e8",
  measurementId: "G-5NW0Z6J3CT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log(analytics)

 